import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import InputBox from '../Input/InputBox';

function TextArea(props) {
  return /*#__PURE__*/React.createElement(InputBox, _extends({
    as: "textarea",
    tabIndex: 0,
    minWidth: "100%",
    maxWidth: "100%"
  }, props));
}

export default TextArea;